import { render, staticRenderFns } from "./train-select.vue?vue&type=template&id=78b1da7c&scoped=true&"
import script from "./train-select.vue?vue&type=script&lang=js&"
export * from "./train-select.vue?vue&type=script&lang=js&"
import style0 from "./train-select.vue?vue&type=style&index=0&id=78b1da7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b1da7c",
  null
  
)

export default component.exports